export default {
  methods: {
    /**
     * When the sidebar is expanded on screens < lg, a grey overlay is placed on the main content.
     * Therefore, to avoid an obtrusive UX when a page is initially loaded/shown the sidebar should
     * remain collapsed on smaller screens. This mixin helps decide when to expand the sidebar
     */
    canExpandSidebar () {
      return this.$vuetify.breakpoint.lgAndUp
    }
  },

  watch: {
    '$vuetify.breakpoint.lgAndUp' (current, previous) {
      if (previous !== undefined) { // undefined when the page loads and $vuetify.breakpoint.lgAndUp is set the first time. This does not indicate a screen size change so ignore it.
        this.$store.dispatch('layout/collapse')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/layout.js